export default __webpack_public_path__ + "static/media/smartobject.dd6ad1db.txt";